export default {
  props: {
    eventId: [Number, String, Object],
    isWalkin: [Number, String, Object],
    propListFilter: Object,
    minFilterDateTime: String,
    maxFilterDateTime: String,
    showWaitlist: Boolean,
    showColumns: Object
  }
}
